import React from "react";
import { Button } from "react-bootstrap";

//
import { icons } from "helpers/constants";
import { confirmPopup, ucFirst } from "helpers/common";

const Planet = ({ data, toggleEnable, handlePlanetPop, handleDelete }) => {
  const handleChange = () => {
    toggleEnable(data.key, !data.enabled);
  };

  const handleClickDelete = async () => {
    try {
      let response = await confirmPopup("This planet will be deleted from the workbook");
      if(response) {
        handleDelete(data.key);
      }
    } catch (err) {
      console.log("Error deleting planet", err);
    }
  }

  return (
    <li className="position-relative ps-4 d-flex align-items-center fw-sbold py-1 justify-content-between">
      <div className="left d-flex align-itmes-center">
        {data.enabled}
        <input
          type="checkbox"
          id={data.key}
          className="form-check m-0"
          checked={data.enabled}
          onChange={handleChange}
        />
        <Button
          onClick={handleClickDelete}
          className="p-0 ms-2 themeClr"
          variant="transparent"
        >
          <i className="fa fa-trash-o" aria-hidden="true"></i>
        </Button>
        <label
          htmlFor={data.key}
          className="form-label d-flex ms-2 align-items-center text-dark fw-sbold m-0"
        >
          <span className="icn me-2">{icons[data.name]}</span>
          {ucFirst(data.name)}
          <span
            style={{
              height: "15px",
              width: "15px",
              backgroundColor: data.lineColor,
              marginLeft: "10px",
              borderRadius: "5px"
            }}
          >
          </span>
          {/* <span style={{ fontSize: 8 }}>
          {props.aspect}
          </span> */}
        </label>
      </div>

      <div className="right">
        <Button
          onClick={handlePlanetPop}
          className="border-0 p-0 px-2"
          variant="transparent"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="6"
            height="10"
            viewBox="0 0 6 10"
            fill="none"
          >
            <path
              d="M0.958008 0.916341L5.04134 4.99967L0.958008 9.08301"
              stroke="#828282"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </Button>
      </div>
    </li>
  );
};

export default React.memo(Planet);
